import { useQuery } from '@tanstack/react-query';

import { fetchMyDosespotClinicianInfo } from '../api/getMyDosespotClinicianInfo.js';
import { dosespotClinicianKeys } from './keys.js';

export function myDosespotClinicianInfoQueryDefinition() {
  return {
    queryKey: dosespotClinicianKeys.myInfo(),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchMyDosespotClinicianInfo(signal),
    meta: {
      toast: {
        title: 'Could not load clinician info',
        description: 'Your DoseSpot clinician information could not be fetched.',
      },
    },
  } as const;
}

export function useMyDosespotClinicianInfoQuery(enabled = true) {
  return useQuery({
    ...myDosespotClinicianInfoQueryDefinition(),
    enabled,
  });
}
